import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _keysInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/keys";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/values";
import * as _ from "../../../util/lodash";

/**
  Helper function to get a forms errors list
**/
var getFormErrors = function getFormErrors(form) {
  if (form === void 0) {
    form = {};
  }

  //  extract the 'errors' prop for each fieldId
  var errors = _reduceInstanceProperty(_).call(_, _keysInstanceProperty(_).call(_, form), function (memo, fieldId) {
    memo[fieldId] = _.get(form, [fieldId, 'errors'], []);
    return memo;
  }, {});

  return errors;
};
/**
  Helper function to get a form's field values
**/


var getFormValues = function getFormValues(form) {
  if (form === void 0) {
    form = {};
  }

  //  extract the 'value' prop for each fieldId
  var formValues = _reduceInstanceProperty(_).call(_, //  we don't need to worry about the 'form' level prop as it is reserved for form level validation errors
  _keysInstanceProperty(_).call(_, _.omit(form, 'form')), function (memo, fieldId) {
    memo[fieldId] = _.get(form, [fieldId, 'value']);
    return memo;
  }, {});

  return formValues;
};
/**
  Helper function to get a form's field validation contexts
**/


var getFormFieldContexts = function getFormFieldContexts(form) {
  if (form === void 0) {
    form = {};
  }

  //  extract the 'value' prop for each fieldId
  var formFieldContexts = _reduceInstanceProperty(_).call(_, //  we don't need to worry about the 'form' level prop as it is reserved for form level validation errors
  _keysInstanceProperty(_).call(_, _.omit(form, 'form')), function (memo, fieldId) {
    memo[fieldId] = _.get(form, [fieldId, 'validationContext']);
    return memo;
  }, {});

  return formFieldContexts;
};
/**
*  Helper function to get field validators.
*
*/


var getFieldValidators = function getFieldValidators(form, fieldId) {
  return _.get(form, [fieldId, 'validators'], {});
};
/**
*  Helper to get form validators
*
*/


var getFormValidators = function getFormValidators(form) {
  return _.get(form, ['form', 'validators'], {});
};
/**
  Helper function to get a field validation context
**/


var getFieldContext = function getFieldContext(form, fieldId) {
  if (form === void 0) {
    form = {};
  }

  return _.get(form, [fieldId, 'validationContext']);
};
/**
  Helper function to get the derived 'isValid' value using the form's errors
**/


var isFormValid = function isFormValid(form) {
  if (form === void 0) {
    form = {};
  }

  var errors = getFormErrors(form);
  return _findInstanceProperty(_).call(_, _valuesInstanceProperty(_).call(_, errors), function (value) {
    return !_.isEmpty(value);
  }) === undefined;
};
/**
  Helper function to get the derived 'isDirty' value using the form's fields
**/


var isFormDirty = function isFormDirty(form) {
  if (form === void 0) {
    form = {};
  }

  var foundDirty = _findInstanceProperty(_).call(_, _.omit(form, 'errors'), ['isDirty', true]);

  return foundDirty !== undefined;
};

export { getFormErrors, getFormValues, getFieldValidators, getFormValidators, getFieldContext, getFormFieldContexts, isFormValid, isFormDirty };
//# sourceMappingURL=form-utils.js.map